import React, { useState,useRef } from 'react';
import { DataGrid, EditModal, UploadButton, UploadModal, DownloadButton } from "../../../common";
import { onDownloadXlsFile, getCultureFromLs } from '../../../utils/commonFunctions';
import { APIEndpoint} from '../../../utils/axios';
import { useTranslation } from 'react-i18next';
import Edit2 from "../../../assets/edit2.svg";
import usePermissions from '../../../utils/userPermissions';
const Columns = [
  { field: 'code', headerName: 'Vendor Code',tooltipField:"code",  resizable:true,filter: true, minWidth: 150,flex:1, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },suppressSizeToFit:true },
  { field: 'name', headerName: 'Name', tooltipField: 'name',flex:1,resizable:true, suppressSizeToFit:true, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },  filter: true, minWidth: 190 },
  { field: 'name2', headerName: 'Name 2', tooltipField: 'name2',flex:1, suppressSizeToFit:true, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, filter: true, minWidth: 190,resizable:true },
  { field: 'sapVendorCode', headerName: 'SAP Vendor Code',tooltipField:"sapVendorCode",resizable:true,  filter: true, minWidth: 160 ,flex:1, suppressSizeToFit:true,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  { field: 'mobile', headerName: 'Mobile',  filter: true, minWidth: 160, flex:1, suppressSizeToFit:true, maxWidth:260},
  { field: 'email', headerName: 'Email',  filter: true, minWidth: 200,
    tooltipField: 'email',
   flex:1, suppressSizeToFit:true,resizable:true,
   cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },
  },
  { field: 'address', headerName: 'Address', resizable:true,filter: true, minWidth: 200,
    tooltipField: 'address',flex:1, suppressSizeToFit:true,
    cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },
  },
  { field: 'gstin', headerName: 'GSTIN',tooltipField: 'gstin', cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, filter: true,resizable:true, minWidth: 200 ,flex:1, suppressSizeToFit:true,},
];

const FormFields = [
  { label: 'Name 1', attribute: 'name', type: 'text', required: true,placeholder: 'Vendor Name 1' },
  { label: 'Name 2 ', attribute: 'name2', type: 'text', required: true,placeholder: 'Vendor Name 2' },
  { label: 'Vendor Code', attribute: 'code', type: 'text', required: true },
  { label: 'SAP Vendor Code', attribute: 'sapVendorCode', type: 'text' },
  { label: 'Email', attribute: 'email', type: 'email',required: true ,placeholder: 'Email Address'},
  { label: 'Mobile', attribute: 'mobile', type: 'text',placeholder: 'Mobile Number' },
  { label: 'PAN', attribute: 'pan', type: 'text',placeholder: 'Vendor PAN Number' },
  { label: 'GSTIN', attribute: 'gstin', type: 'text' ,placeholder: 'Vendor GSTIN Number'},
  { label: 'Address', attribute: 'address', type: 'textarea', rows: 3 ,placeholder: 'Address',className:"margTop26"},
  { label: 'Street 1', attribute: 'street1', type: 'text' },
  { label: 'Street 2', attribute: 'street2', type: 'text' },
  { label: 'Street 3', attribute: 'street3', type: 'text' },
  { label: 'Postal Code', attribute: 'postalCode', type: 'text', required: true },
  { label: 'City', attribute: 'city', type: 'text', required: true },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true },
  { label: 'Country', attribute: 'country', type: 'text', required: true, disabled: true, initialValue: '' },
]

export const VendorsPage = (props) => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({ isListReady: false, filterBase: '', resetDataSource: false, })
  const [statesIN, setStatesIN] = useState([]);
  const[countryDetails,setCountryDetails]=useState({});
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [ uploadedFile, setUploadedFile ] = useState([]);
 const timeOutRef=useRef(null);

  const { hasPermission: createvendors } = usePermissions('create', "orn:Account:ManageVendorMaster");
  const { hasPermission: editvendors } = usePermissions('edit', "orn:Account:ManageVendorMaster");
  const { hasPermission: uploadvendors } = usePermissions('upload', "orn:Account:ManageVendorMaster");
  const { hasPermission: downloadvendors } = usePermissions('download', "orn:Account:ManageVendorMaster");

  React.useEffect(() => {
    const  fetchCountryData=async()=>{
     try {
       const res = getCultureFromLs()
       if (res) {
         setCountryDetails(res);
       }
     } catch (error) {
       console.error('Error fetching country data:', error);
     }
     }
     fetchCountryData();
     const refC=timeOutRef.current;
return ()=>{
  if(refC){
   clearTimeout(refC);
  }
}
   }, []);

    React.useEffect(() => {
 if(Object.keys(countryDetails).length){
   const statesMod = countryDetails.stateCodes.map((obj, index) => ({
     key: index + 1,
     label: obj.name,
     value: obj.code,
   }));
   setStatesIN(statesMod);

 }
   }, [countryDetails]);

function setTimeOutFileUpload(){
 timeOutRef.current = setTimeout(()=>{
  setState((_)=>({..._,resetDataSource:!_.resetDataSource}));
  },2500)
}
  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchVendors = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    let res = await APIEndpoint.post('vendors/process', filterData);
    return res;
  }
  const handleModalClose = () => {
    setModalFormStatusObj({text:""})
    setState((currentState) => {
      return { ...currentState, showAddForm: false, editRow: null }
    })

  }
  const handleAddVendor = () => {
    setState((_) => {
      return { ..._, showAddForm: createvendors?true:false }
    })
  }
  const handleReset = () => {
    setState((_) => {
      return { ..._, resetDataSource: true, showAddForm: false, editRow: null };
    })
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setModalFormStatusObj({text:""})
      setState((_) => {
        return { ..._, resetDataSource: false };
      })
    }, 500)
  }
  const handleWarehouseFormSubmit = async (e, values) => {
    let isValid = true, isEdit = Boolean(state.editRow);
    if (values != null) {
      isValid = FormFields.every(((field) => {
        if (
          field.required && (
            (isEdit && !(values[field.attribute] || state.editRow[field.attribute])) ||
            (!isEdit && !values[field.attribute] && field.attribute !== 'country')
          )
        ) {
          setModalFormStatusObj({error: "Please fill all mandatory fields"});
          return false;
        }
        return true
      }));
      if (isValid) {
        try {
          let res;
          if (isEdit) {
            values = { ...state.editRow, ...values };
            res = await APIEndpoint.post('vendors/update/' + state.editRow.id, values);
          } else {
            values.country = 'IN'
            res = await APIEndpoint.post('vendors/new', values);
          }
          if (res && res.success) {
            setModalFormStatusObj({text:res?.msg})
            setTimeout( () => {
              handleReset()
          }, 1500 );

          }


        } catch (error) {
          let {data}=JSON.parse(error.message);
          setModalFormStatusObj({error:data?.msg})
        }
      }
    }
  }
  const handleRowAction = async (e, action, row) => {
    let editRow = null;
    const vendor = await APIEndpoint.get('vendors/' + row.itemId);
    if (vendor.success) {
      editRow = vendor.result;
      setState((currentState) => {
        return { ...currentState, editRow: editRow }
      })
    } else {
      alert('Unable to fetch vendor')
    }
  }

  const onUploadClose = () => {
    setUploadedFile([]);
    setUploadFileStatusBlock('');
    setState((_) => ({ ..._, showUpload: false }))
  };

  const handleUploadVendors = async (e) => {
    try {
    const formData = new FormData()
    formData.append('file', e.target.files[0]);
    setUploadedFile(e.target.files[0])
    await APIEndpoint.post('vendors/master/upload', formData, { 'Content-Type': "multipart/form-data" });
    setTimeOutFileUpload();
    } catch (error) {
      e.target.value = null;
      let { status, data } = JSON.parse(error.message);
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data?.errors) {
        data.errors.forEach((errorItem) => {
          const lineNum = errorItem.lineNumber;
          const errorMsgArr = [];

          errorItem.errors.forEach((erObj) => {
            errorMsgArr.push(
              `<strong>${erObj.field}:</strong> ${erObj.message} <br>`
            );
          });

          msgContent += `<br><strong>Line ${lineNum}:</strong> <br>` + errorMsgArr.join(" ");
        });
      } else if (status === 0 && !data) {
        msgContent += `Error occurred while uploading vendors!<br>Please try again.`;
      }
      else if(status === 400 && data && data?.Error){
        msgHeading = data?.Error;
        msgContent += `Error occurred while uploading vendors!<br>Please fix the errors and re-upload.`;
      }
      else {
        msgContent += `Error occurred while uploading vendors!<br>Please fix the errors and re-upload.`;
      }

      // Displaying the message with proper structure
      setUploadFileStatusBlock(
        `<p class='listErrorMessagesCls'><strong>${msgHeading}</strong></p>` +
        `<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>${msgContent}</p>`
      );

    }
  }
  const onDownloadSampleFile = async (e) => {
    onDownloadXlsFile('samples/downloads/Vendor_Master_Upload_Sample', 'Vendor_Master_Upload_Sample')
  }
  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

      <DataGrid
        columnResize
        resetDataSource={state.resetDataSource}
        showDefaultFilters
        className='full-flex'
        columns={Columns}
        getRows={fetchVendors}
        pageType={false}
            RightComponent={() => {
                  return ( uploadvendors && downloadvendors) ? (
<div className="flexRow justifyContentFlexEnd alignItemsCenter">
        <UploadButton
        className="buttonWithMargin margBottom0"
          onClick={() => setState((_) => ({ ..._, showUpload: true }))}
          showLabel={false}
          label={t('pages.pagesContent.vendors.uploadBtn')} />
        <DownloadButton
        className="buttonWithMargin margBottom0"
          showLabel={false}
          downloadLink='downloads/vendorMaster'
          label={t('pages.pagesContent.vendors.downloadBtn')}/>
      </div>
                  ) : null;
                }}
        addButton={{
          title: t('pages.pagesContent.vendors.addButtonTitle'),
          onClick: handleAddVendor
        }}
        actions={[
          { detail: editvendors?[{ src: Edit2, value: "edit" ,title:'Edit'}]:[] }
        ]}
        onAction={handleRowAction}
      />
      {
        Boolean(state.showAddForm || state.editRow) &&
        <EditModal
          title={
            Boolean(state.editRow) ? t('pages.pagesContent.vendors.editModalTitle') :
              t('pages.pagesContent.vendors.addModalTitle')
          }
          onClose={handleModalClose}
          onSubmit={handleWarehouseFormSubmit}
          buttonLabel={t('buttons.save')}
          modalFormStatusObj={modalFormStatusObj}
          fields={
            FormFields.map((field) => {
              const isEdit = Boolean(state.editRow);
              let initialValue = '';
              if (isEdit) {
                initialValue = state.editRow[field.attribute] ?? '';
                  field.disabled=true;
              } else if (field.attribute === 'country') {
                initialValue = countryDetails?.countryCode || '';
                  field.disabled=false;
              } else {
                initialValue = field.initialValue || '';
                  field.disabled=false;
              }

              return {
                ...field,
                initialValue,
                options: field.attribute === 'stateCode'
                  ? [{ label: t('selectState'), value: '' },{ label: 'Others', value: 'others' }, ...statesIN.map(st => ({ label: st.label, value: st.value }))]
                  : []
              };
            })
          }
        />
      }
      {
        state.showUpload &&
        <UploadModal
          onUploadFileChangeHandler={handleUploadVendors}
          modelTitle={t('pages.pagesContent.vendors.uploadBtn')}
          onUploadClose={onUploadClose}
          onDownloadSampleFile={onDownloadSampleFile}
          uploadFileStatusBlock = { uploadFileStatusBlock }
          uploadedFile={uploadedFile}
        />
      }
       {
                 !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}